import { colors } from "./colors";

export const semanticColors = {
  background: {
    canvas: colors.gray[50],
    paper: colors.gray.white,
    subtle: colors.gray[50],
    tooltip: "#181D27",
  },
  surface: {
    disabled: "#F5F5F5",
    invited: "#F3F5F7",
    blueBg: colors.blue[50],
    blueBgMuted: "#E0F0FF",
    uploadSelection: colors.gray[100],
  },
  text: {
    primary: colors.gray[900],
    secondary: colors.gray[700],
    tertiary: colors.gray[500],
    muted: colors.gray[400],
    disabled: colors.gray[300],
    subtle: "#666666",
    inverse: colors.gray.white,
    tooltip: "#D5D7DA",
  },
  border: {
    subtle: colors.gray[100],
    disabled: colors.gray[200],
    editable: "#888888",
    actionMuted: colors.blue[200],
    action: colors.brand.blue,
    strong: "#CCCCCC",
  },
  interactive: {
    primary: colors.blue[500],
    primaryStrong: colors.blue[600],
    primaryAccent: "#75BBFF",
    rangeBaseline: colors.blue[400],
    secondarySurface: "#E0F0FF",
    secondarySurfaceHover: colors.blue[200],
  },
  feedback: {
    success: {
      main: colors.green[600],
      strong: colors.green[700],
    },
    warning: {
      main: colors.orange[600],
      strong: colors.orange[600],
    },
    error: {
      main: colors.red[600],
      dark: "#922D37",
      destructive: "#D32F2F",
      strong: colors.red[700],
    },
  },
  notification: {
    info: {
      border: "#A8D0F7",
      background: "#E0F0FF",
      text: colors.blue[500],
    },
    warning: {
      border: "#F39C12",
      background: "#FFFAE0",
      text: colors.gray[500],
    },
    error: {
      border: "#9F0037",
      background: "#F2CFCC",
      text: colors.gray[500],
    },
  },
  completeness: {
    high: "#4CAF50",
    medium: "#F4D03F",
    low: "#F44336",
    track: "#E6E6E6",
  },
  icon: {
    neutral: "#4B4B5A",
  },
  state: {
    inactive: "#ADB5BC",
  },
  sidebar: {
    background: colors.blue[500],
    hoverBackground: colors.blue[700],
    text: colors.gray.white,
    selectedText: colors.blue[500],
    selectedBackgroundStart: colors.brand.brown,
    selectedBackground: colors.gray[50],
  },
} as const;

export type SemanticColors = typeof semanticColors;
